import { State, toDataSourceRequestString } from "@progress/kendo-data-query";

export function toRequestStringWithoutPage(dataState: State) {
  return toDataSourceRequestString({
    ...dataState,
    skip: 0,
    take: -1,
  });
}
